<template>
  
  <!-- <div class="container">
    <div class="left-item navbar-element navbar" @click="onDoneClick">&lt;Done</div>
    <div class="center-item">{{ title }}</div>
    <div class="right-item navbar-element navbar" @click="onMicrophoneClick">
      <span v-show="!isMuted">Mute</span>
      <span v-show="isMuted" class="muted">listen</span>
    </div>
  </div> -->



  <div>
    <ion-header>
      <ion-toolbar>
        <ion-buttons v-show="props.showDone" slot="start">
          <ion-button size="small" @click="onDoneClick">&lt;{{ doneString }}</ion-button>
        </ion-buttons>
        <ion-title class="ion-text-center">{{ title }}</ion-title>
        <ion-buttons v-show="props.showMute" slot="end">
          <ion-button size="small" @click="onMicrophoneClick">
                  <span v-show="!isMuted">{{ muteString}}</span>
                  <span v-show="isMuted" class="muted">{{ listenString }}</span>
          </ion-button>
          <!-- <ion-button> End </ion-button> -->
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
  </div>
</template>

<script setup>

import { IonIcon,IonButton, IonButtons, IonContent, IonHeader, IonMenu, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';

import { ref, watch } from 'vue'
import { computed } from "@vue/reactivity"
import { translateEnglishWords } from '@/composables/translation';

const emit = defineEmits(['topline-click'])

const props = defineProps({
    title : {
      type : String,
      default : "title"
    },
    microphoneIsMuted : {
      type : Boolean,
      default : false
    },
    showDone : {
      type : Boolean,
      default : true
    },
    showMute : {
      type : Boolean,
      default : true
    }
  })

  const doneString = ref(translateEnglishWords("Done"))
  const muteString = ref(translateEnglishWords("Mute"))
  const listenString = ref(translateEnglishWords("Listen"))

  const isMuted = ref(props.microphoneIsMuted)

  const title = computed({ get() { 
      return (props.title) }}
  )
  
  const microphoneIsMuted = computed({ get() { return props.microphoneIsMuted }})

  watch (microphoneIsMuted , (newVal,oldVal) => {
      console.log("**** microphone in topline   is it muted? ",newVal)
      isMuted.value = newVal
  })

 
  function onDoneClick() {
    emit("topline-click","done")

  }

  function onMicrophoneClick() {
    emit("topline-click","microphone")
  }

</script>

<style scoped>

.muted {
  color : red;
  font-size: 18px;
  padding-top:4px;
}
</style>